<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Budget Costing Items
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col lg="3">
            <b-input-group >
                <b-input-group-prepend><span class="pt-2 mr-2">Item Name</span></b-input-group-prepend>
                <b-form-input v-model="tblData.jccostname" ></b-form-input>
            </b-input-group>
        </b-col>
        <b-col lg="3">
            <b-input-group >
                <b-input-group-prepend><span class="pt-2 mr-2">Item Code</span></b-input-group-prepend>
                <b-form-input v-model="tblData.jccostcode" ></b-form-input>
            </b-input-group>
        </b-col>
        <b-col md="5">
              <b-row>
                <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                <b-button class="btn btn-secondary mr-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
              </b-row>
        </b-col>
      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(jccostcode)="data">
          <span v-if="(data.item.judul=='Y')"  style="font-weight:bold;">{{data.item.jccostcode}}</span>
          <span v-else >{{data.item.jccostcode}}</span>
        </template>
        <template v-slot:cell(jccostname)="data">
          <span v-if="(data.item.judul=='Y')" v-html="data.item.accname" style="font-weight:bold;"></span>
          <span v-else v-html="data.item.accname"></span>
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="2" >
            <b-input-group >
                <b-input-group-prepend><span  class="pt-1 mr-2">Limit per page</span></b-input-group-prepend>
                <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card >
          <div slot="header">Budget Costing Item - Add/Edit Form 
          </div>
                <b-input-group >
                    <b-input-group-prepend><label>Item Name</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.jccostname" :state="!$v.frmdata.jccostname.$error" ></b-form-input>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label>Item Code</label></b-input-group-prepend>
                    <b-form-input v-model="frmdata.jccostcode" :state="!$v.frmdata.jccostcode.$error"></b-form-input>
                    <b-input-group-prepend><span class="ml-5 pt-2 mr-2">Unit Size</span></b-input-group-prepend>
                    <b-form-input v-model="frmdata.unitsize" ></b-form-input>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label>Judul</label></b-input-group-prepend>
                    <b-form-select v-model="frmdata.judul" :plain="true" :options="['','Y']" ></b-form-select>
                    <b-input-group-prepend><span class="ml-5 pt-2 mr-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Level</span></b-input-group-prepend>
                    <b-form-input v-model="frmdata.level_" type="number" ></b-form-input>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label>GL Account#</label></b-input-group-prepend>
                    <b-form-input readonly v-model="frmdata.accinfo" ></b-form-input>
                    <b-input-group-append>
                    <b-btn text="Button" @click="lkuCoaShow=true" >
                        <i class="fa fa-search"></i>
                    </b-btn>
                    </b-input-group-append>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label >Master Item/Inventory</label></b-input-group-prepend>
                    <b-form-input readonly v-model="frmdata.iteminfo" ></b-form-input>
                    <b-input-group-append>
                    <b-btn text="Button" @click="lkuItemShow=true" >
                        <i class="fa fa-search"></i>
                    </b-btn>
                    </b-input-group-append>
                </b-input-group>

            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
             <b-button variant="secondary" class="mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>
        </b-card>
        </b-col>
    </b-row>
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>        
        <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Master Item" :centered="true">
            <lku-item @click="onSelectLkuItem" isactive="1" :formdata="itemList"></lku-item>
        </b-modal>        

  </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 160px;
            }
        }
    }
</style>


<script>
import toastr from "mini-toastr";
import budgetcostitem from "../../apis/budgetcostitem";
import lkuItem from "../lookup/lkuItemLazzy";
import lkuCoa from "../lookup/lkuCoa";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
        jccostcode: { required },
        jccostname: { required },
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      showList:true,
      showForm:false,
      lkuCoaShow:false,
      tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
      lkuItemShow:false,
      itemList:{},
      frmdata:{jccostcode: '',jccostname:'' },
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'jccostcode',
        sortDesc: false
      },
    };
  },
  components:{lkuCoa,lkuItem},
  computed: {
    tblFields(){
      const fields=[
          {
            key: "jccostcode",
            label: "Item Code",
            sortable: true
          },
          {
            key: "jccostname",
            label: "Item Name",
            sortable: true
          },
          {
            key: "kodeacc",
            label: "GL Account#",
            sortable: true
          },
          {
            key: "partnumber",
            label: "Master Item/Inventory",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  methods: {
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await budgetcostitem.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.jccostcode= '';
        this.tblData.jccostname= '';
        this.refresh();
    },    
    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.frmdata.idlama = data.jccostkey;
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              this.frmdata.level_ = this.frmdata.level_ || 1;
              await budgetcostitem.save(this.frmdata);
              setTimeout(() => {
                  this.refresh();              
              }, 100);       
              this.closeFrm();              
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      // await budgetcostitem.remove({tablename:'budget-costitem', key:this.model.jccostkey});
      await budgetcostitem.remove(this.model);
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    onSelectLkuCoa(_selected) {
        this.frmdata.accinfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        this.frmdata.namaacc = _selected.namaacc;
        this.frmdata.kodeacc= _selected.kodeacc;
        this.lkuCoaShow=false;
    },
    onSelectLkuItem(lkuData) {
        this.itemList=lkuData;
        this.lkuItemShow=false;
        this.frmdata.iteminfo = lkuData.selected.partnumber.trim() + ' | ' + lkuData.selected.itemname.trim();
        this.frmdata.partnumber = lkuData.selected.partnumber;
        this.frmdata.itemno = lkuData.selected.itemno;
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
